import { render } from "./Login.vue?vue&type=template&id=3c8f8b64&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3c8f8b64"

export default script